import '@/assets/tailwindcss/styles.css';
import '@/assets/less/index.less';

import * as dotenv from 'dotenv';
import moment from 'moment-business-days';
import numeral from 'numeral';
import React from 'react';
import ReactDOM from 'react-dom';

import { HOLIDAYS } from '@/constants';
import MainProvider from '@/contexts/MainProvider';

import App from './App';
import * as serviceWorker from './serviceWorker';

dotenv.config();

numeral.register('locale', 'es', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '$'
  }
});

// switch between locales
numeral.locale('es');

moment.updateLocale('es', {
  holidays: HOLIDAYS,
  holidayFormat: 'MM-DD'
});

ReactDOM.render(
  <MainProvider><App/></MainProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
